/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.25.1
 */

import { IconButton } from '@nexign/scc-ui-kit';
import styled from 'styled-components';

export const StyledIconButtonCell = styled(IconButton)`
    padding: 4px;
`;
